/**
 * @override
 * Override base fragment to include blogContent.json but NOT links.
 * Links are fetched separately via useBlogLinks hook with error handling.
 * This ensures content always renders even if embedded entries are unpublished.
 *
 * Also includes contentfulMetadata for tags support (not in autogenerated version).
 * Includes blogTileImage for blog listing cards (using inline fragment for union type).
 */

import gql from 'graphql-tag';

import {BaseImageFragment} from '@amblique/contentful/app/contentful/fragments/image/base-image.fragment';

export const BaseBlogFragment = gql`
  ${BaseImageFragment}

  fragment BaseBlogFragment on Blog {
    __typename
    sys {
      id
    }
    author
    blogCategory
    blogContent {
      json
    }
    blogHeaderMedia {
      url
      title
      description
      contentType
    }
    blogTileImage {
      ... on Image {
        ...BaseImageFragment
      }
    }
    datePublished
    description
    duration
    title
    url
    contentfulMetadata {
      tags {
        id
        name
      }
    }
  }
`;
